// import "bootstrap/dist/css/bootstrap.min.css";
import Animation from "@/components/Animation";
import { Card, CardContent } from "@/components/ui/card";
import { isAssistant } from "@/hooks/utils";
import { subscriptionTierMapper } from "@/scripts/subscriptionTierMapper";
import { Ticket, Timer, WalletMinimal } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import ChangeTutorPassword from "./ChangeTutorPassword";
import EditPortal from "./EditPortal";

const MainDashPage = () => {
  const { userProfileData } = useAppSelector((state) => state.store);
  const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false);
  const dispatch = useAppDispatch();
  const [params] = useSearchParams();

  useEffect(() => {
    if (params.get("prices") === "1") {
      const prices = document.getElementById("prices");
      if (prices) {
        prices.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  const endDateFormatter = (date: number | string) => {
    if (!date || +date < Date.now())
      return { isEnded: true, msg: "إنتهت الباقة" };

    const endDate = new Date(+date).toLocaleString("en-US", {
      month: "numeric",
      day: "numeric",
    });

    const days = Math.ceil((+date - Date.now()) / (1000 * 60 * 60 * 24));

    return { isEnded: false, msg: `${endDate} (${days} يوم)` };
  };

  return (
    <Animation>
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <Card className="aspect-[2/1]">
            <CardContent className="px-6 py-4">
              <div className="flex items-center justify-between">
                <p className="text-sm font-medium text-gray-600">
                  الباقة الحالية
                </p>
                {
                  subscriptionTierMapper(
                    endDateFormatter(userProfileData?.subscription_end_date)
                      .isEnded
                      ? "free"
                      : userProfileData?.subscription_tier
                  ).icon
                }
              </div>
              <p className="text-2xl font-bold">
                {
                  subscriptionTierMapper(
                    endDateFormatter(userProfileData?.subscription_end_date)
                      .isEnded
                      ? "free"
                      : userProfileData?.subscription_tier
                  ).title
                }
              </p>
            </CardContent>
          </Card>

          <Card className="aspect-[2/1]">
            <CardContent className="px-6 py-4">
              <div className="flex items-center justify-between">
                <p className="text-sm font-medium text-gray-600">
                  صلاحية الباقة
                </p>
                <Timer className="size-8 text-red-600" />
              </div>
              <p className="text-2xl font-bold">
                {endDateFormatter(userProfileData?.subscription_end_date).msg}
              </p>
            </CardContent>
          </Card>

          <Card className="aspect-[2/1]">
            <CardContent className="px-6 py-4">
              <div className="flex items-center justify-between">
                <p className="text-sm font-medium text-gray-600">
                  رصيد المحفظة
                </p>
                <WalletMinimal className="size-8 text-blue-600" />
              </div>
              <p className="text-2xl font-bold">
                {userProfileData?.wallet_credit ?? 0}
              </p>
            </CardContent>
          </Card>

          <Card className="aspect-[2/1]">
            <CardContent className="px-6 py-4">
              <div className="flex items-center justify-between">
                <p className="text-sm font-medium text-gray-600">
                  الأكواد المجانية
                </p>
                <Ticket className="size-8 text-orange-600" />
              </div>
              <p className="text-2xl font-bold">
                {userProfileData?.free_codes_credit ?? 0}
              </p>
            </CardContent>
          </Card>
        </div>

        <h5 className="text-cyan-600 p-4 bg-cyan-50 rounded-lg border border-cyan-500 flex gap-1 shadow-sm flex-col md:flex-row">
          لتغيير الباقة أو التعرف على الأسعار
          <Link
            to="/subscription-plans"
            className="text-cyan-600 mx-1 no-underline font-bold"
          >
            إضغط هنا
          </Link>
        </h5>

        {!isAssistant() && <EditPortal />}

        <ChangeTutorPassword />
      </div>
    </Animation>
  );
};

export default MainDashPage;
